/*
 * Goloka V3 floating cart pill.
 * - Server-rendered by snippets/v3-floating-cart.liquid, refreshed from /cart.js after any cart change
 *   (Dawn's PUB_SUB cart-update event, plus a fetch/XHR-free fallback on cart-drawer mutations).
 * - First add of the session expands into a one-row "X added" tray for ~4.5s; later adds pulse.
 * - Opens Dawn's <cart-drawer>. DISPLAY ONLY: reward progress is computed from the subtotal using thresholds from theme settings; real
 *   discounts must be Shopify automatic discounts.
 */
(function () {
  if (window.__v3Fc) return;
  window.__v3Fc = true;

  var INTRO_KEY = 'goloka.v3.floatingcart.intro';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function introSeen() {
    try { return sessionStorage.getItem(INTRO_KEY) === '1'; } catch (e) { return false; }
  }
  function markIntroSeen() {
    try { sessionStorage.setItem(INTRO_KEY, '1'); } catch (e) { /* non-fatal */ }
  }
  function plural(n) { return n + (n === 1 ? ' item' : ' items'); }

  function init() {
    var root = document.querySelector('[data-v3-fc]');
    if (!root || root.dataset.v3Ready) return;
    root.dataset.v3Ready = '1';
    // Fixed + transformed ancestors (sticky header) can displace it: live on <body>.
    document.body.appendChild(root);

    var currency = root.dataset.currency || 'INR';
    // Offer tiers come from theme settings (Goloka offers) via <script id="v3-offers-data">. Rupees -> paise.
    var offerTiers = [];
    try {
      var offerData = JSON.parse(document.getElementById('v3-offers-data').textContent);
      offerTiers = (offerData.tiers || []).filter(function (t) { return t.t > 0; });
    } catch (e) { /* no offers data: no progress */ }
    var ladder = offerTiers.map(function (t) { return t.t * 100; });
    var introMs = parseInt(root.dataset.introMs, 10) || 4500;
    var fan = root.querySelector('[data-fc-fan]');
    var countEl = root.querySelector('[data-fc-count]');
    var totalEl = root.querySelector('[data-fc-total]');
    var progress = root.querySelector('[data-fc-progress]');
    var live = root.querySelector('[data-fc-live]');
    var tray = root.querySelector('[data-fc-tray]');
    var compact = root.querySelector('.v3fc__compact');
    var trayImg = root.querySelector('[data-fc-tray-img]');
    var trayTitle = root.querySelector('[data-fc-tray-title]');
    var traySub = root.querySelector('[data-fc-tray-sub]');
    var prevCount = parseInt(root.dataset.count, 10) || 0;
    var holdTray = false;
    var trayTimer = null;
    var fetchTimer = null;

    function money(cents) {
      var v = cents / 100;
      try {
        return new Intl.NumberFormat(currency === 'INR' ? 'en-IN' : undefined, {
          style: 'currency', currency: currency,
          minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2
        }).format(v);
      } catch (e) { return String(v); }
    }

    function progressPct(subtotal) {
      if (!ladder.length) return 0;
      var prev = 0;
      for (var i = 0; i < ladder.length; i++) {
        if (subtotal < ladder[i]) return Math.max(0, Math.min(100, Math.round(((subtotal - prev) / (ladder[i] - prev)) * 100)));
        prev = ladder[i];
      }
      return 100;
    }
    function nextTeaser(subtotal) {
      var teasers = offerTiers.map(function (t) { return t.teaser; });
      for (var i = 0; i < ladder.length; i++) {
        if (subtotal < ladder[i]) return money(ladder[i] - subtotal) + ' to ' + (teasers[i] || 'the next reward').replace(/^an? /, '');
      }
      return '';
    }

    function render(cart) {
      var n = cart.item_count;
      root.classList.toggle('is-empty', n === 0);
      root.dataset.count = n;
      var items = cart.items.slice(0, 3).reverse(); // oldest back-left, newest in front
      fan.innerHTML = '';
      items.forEach(function (it) {
        if (!it.image) return;
        var img = document.createElement('img');
        img.src = it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2');
        img.alt = '';
        img.width = 40; img.height = 40;
        fan.appendChild(img);
      });
      countEl.textContent = plural(n);
      totalEl.textContent = money(cart.total_price);
      var pct = progressPct(cart.items_subtotal_price);
      progress.style.width = pct + '%';
      progress.parentNode.hidden = pct <= 0;
      compact.setAttribute('aria-label', 'View cart: ' + plural(n) + ', ' + money(cart.total_price));
    }

    function drawer() { return document.querySelector('cart-drawer'); }
    function drawerOpen() { var d = drawer(); return !!(d && d.classList.contains('active')); }

    function open(e) {
      var d = drawer();
      if (d && typeof d.open === 'function') {
        e.preventDefault();
        collapseTray();
        d.open(e.currentTarget);
      }
    }
    root.querySelectorAll('[data-fc-open]').forEach(function (a) { a.addEventListener('click', open); });

    function collapseTray() {
      clearTimeout(trayTimer);
      root.classList.remove('is-expanded');
      tray.setAttribute('aria-hidden', 'true');
      tray.tabIndex = -1;
    }
    function expandTray(cart, added) {
      var last = added || cart.items[0];
      if (!last) return;
      var src = last.image || (last.featured_image && last.featured_image.url) || '';
      trayImg.hidden = !src;
      if (src) trayImg.src = src.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2');
      trayTitle.textContent = (last.product_title || last.title || 'Item') + ' added';
      traySub.textContent = nextTeaser(cart.items_subtotal_price) || plural(cart.item_count) + ' · ' + money(cart.total_price);
      root.classList.add('is-expanded');
      tray.setAttribute('aria-hidden', 'false');
      tray.removeAttribute('tabindex');
      startTrayTimer();
    }
    function startTrayTimer() {
      clearTimeout(trayTimer);
      if (holdTray) return;
      trayTimer = setTimeout(collapseTray, introMs);
    }
    root.addEventListener('mouseenter', function () { holdTray = true; clearTimeout(trayTimer); });
    root.addEventListener('mouseleave', function () { holdTray = false; if (root.classList.contains('is-expanded')) startTrayTimer(); });
    root.addEventListener('focusin', function () { holdTray = true; clearTimeout(trayTimer); });
    root.addEventListener('focusout', function () { holdTray = false; if (root.classList.contains('is-expanded')) startTrayTimer(); });

    function pulse() {
      if (reduce) return;
      root.classList.remove('is-pulse');
      void root.offsetWidth;
      root.classList.add('is-pulse');
    }

    // Dawn opens its drawer on add; show the tray once it has closed so it is not hidden behind it.
    function whenDrawerClosed(fn) {
      var d = drawer();
      if (!d || !drawerOpen()) return fn();
      var mo = new MutationObserver(function () {
        if (!drawerOpen()) { mo.disconnect(); fn(); }
      });
      mo.observe(d, { attributes: true, attributeFilter: ['class'] });
    }

    function refresh(added) {
      return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var grew = cart.item_count > prevCount;
          prevCount = cart.item_count;
          render(cart);
          if (!grew) return;
          live.textContent = ((added && (added.product_title || added.title)) ? (added.product_title || added.title) + ' added. ' : '') +
            plural(cart.item_count) + ' in cart, ' + money(cart.total_price) + '.';
          if (!introSeen()) {
            markIntroSeen();
            // Re-read the cart once the drawer closes: quantities may have changed while it was open.
            whenDrawerClosed(function () {
              fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
                .then(function (r) { return r.json(); })
                .then(function (fresh) { render(fresh); if (fresh.item_count > 0) expandTray(fresh, added); })
                .catch(function () { expandTray(cart, added); });
            });
          } else {
            pulse();
          }
        })
        .catch(function () { /* the server-rendered pill stays as is */ });
    }

    var pendingAdded = null;
    function schedule(added) {
      if (added) pendingAdded = added;
      clearTimeout(fetchTimer);
      fetchTimer = setTimeout(function () {
        var a = pendingAdded;
        pendingAdded = null;
        refresh(a);
      }, 80);
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
        var data = evt && evt.cartData;
        var added = data && (data.product_title || data.title) && !data.items ? data : null;
        schedule(added);
      });
    }
    // Server-rendered state may be stale after bfcache restore.
    window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });
    // Editor / drawer re-render of the cart: make sure we reflect the final state.
    document.addEventListener('shopify:section:load', function () { schedule(); });

    // Also catch carts changed by code that does not publish PUB_SUB (quick add variants, other agents' scripts).
    var d0 = drawer();
    if (d0) {
      new MutationObserver(function () { schedule(); }).observe(d0.querySelector('#CartDrawer') || d0, { childList: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
